import React from "react";
import { Col, Row } from "antd";
import './style.scss'

const arrs = [
    {name:'The Bright and Dark Sides of Computer Vision: Challenges and Opportunities for Privacy and Security, CVPR 2017',img:'https://img.alicdn.com/imgextra/i1/O1CN01KEeo4I1psZkLFznsH_!!6000000005416-0-tps-560-316.jpg',link:'https://vision.soic.indiana.edu/bright-and-dark-workshop-2017/'},
    {name:'The Bright and Dark Sides of Computer Vision: Challenges and Opportunities for Privacy and Security, CVPR 2018',img:'https://img.alicdn.com/imgextra/i4/O1CN01iXS3Yo260qkoPGcDg_!!6000000007600-0-tps-560-316.jpg',link:'https://vision.soic.indiana.edu/bright-and-dark-workshop-2018/'},
    {name:'Adversarial Machine Learning in Real-world Computer Vision Systems, CVPR 2019',img:'https://img.alicdn.com/imgextra/i4/O1CN01th55l31o9P43wXC0l_!!6000000005182-0-tps-560-316.jpg',link:'https://amlcvpr2019.github.io/'},
    {name:'Adversarial Machine Learning in Computer Vision, CVPR 2020',img:'https://img.alicdn.com/imgextra/i3/O1CN017GnI3W1LLCPYBDOlb_!!6000000001282-0-tps-560-316.jpg',link:'https://eccv20-adv-workshop.github.io/'},
    {name:'Adversarial Robustness in the Real World, ECCV 2020',img:'https://img.alicdn.com/imgextra/i2/O1CN01Rn6swX2346j1Zm5m3_!!6000000007201-0-tps-560-316.jpg',link:'https://adv-workshop-2020.github.io/'},
]
export default function Previous() {
    return <div className="page-previous">
            <div className="previous-title">Previous Workshops</div>
            <div className="previous-con">
                {arrs.map((item, index) => (
                    <div key={index}>
                        <img src={item.img} alt="" />
                        <a target="_blank" href={item.link}>{item.name}</a>
                    </div>
                ))}
            </div>
        </div>
}

